const messages = {
    en: {
        role: {
            permissions: {
                COBRANZA_MENU: "Access to Cobranza",
                COBRANZA_SHOW: "View Cobranza",
                COBRANZA_AGENCIA_SHOW: "View Cobranza from my agency",
                COBRANZA_CREATE: "Create Cobranza",
                COBRANZA_UPDATE: "Modify Cobranza",
                COBRANZA_DELETE: "Delete Cobranza",
                COBRANZA_ESTADO: "Estado de Cobranzas",
                COBRANZA_EXPORT: "Exportar Cobranzas",
                COBRANZA_EXPORT_IMPUTATION: "Exportar Cobranzas imputadas",
                COBRANZA_EXPORT_AGENCIA: "Exportar Cobranzas Agencia",
                COBRANZA_FILTRO_FECHA_INGRESO: "Ver filtro por fecha de ingreso de Cobranza",
                COBRANZA_TIPIFICAR: "Tipificar Cobranzas",
                COBRANZA_TIPIFICAR_FORZADO: "Tipificar Cobranzas de forma forzada"
            }
        }
    },
    es: {
        role: {
            permissions: {
                COBRANZA_MENU: "Acceder Cobranza",
                COBRANZA_SHOW: "Ver Cobranza",
                COBRANZA_AGENCIA_SHOW: "Ver Cobranzas de mi agencia",
                COBRANZA_CREATE: "Crear Cobranza",
                COBRANZA_UPDATE: "Modificar Cobranza",
                COBRANZA_DELETE: "Eliminar Cobranza",
                COBRANZA_ESTADO: "Estado de Cobranzas",
                COBRANZA_EXPORT: "Exportar Cobranzas",
                COBRANZA_EXPORT_IMPUTATION: "Exportar Cobranzas imputadas",
                COBRANZA_EXPORT_AGENCIA: "Exportar Cobranzas Agencia",
                COBRANZA_FILTRO_FECHA_INGRESO: "Ver filtro por fecha de ingreso de Cobranza",
                COBRANZA_TIPIFICAR: "Tipificar Cobranzas",
                COBRANZA_TIPIFICAR_FORZADO: "Tipificar Cobranzas de forma forzada"
            }
        }
    },
    pt: {
        role: {
            permissions: {
                COBRANZA_MENU: "Acessar Cobranza",
                COBRANZA_SHOW: "Ver Cobranza",
                COBRANZA_AGENCIA_SHOW: "Ver Cobranzas da minha agencia",
                COBRANZA_CREATE: "Criar Cobranza",
                COBRANZA_UPDATE: "Modificar Cobranza",
                COBRANZA_DELETE: "Eliminar Cobranza",
                COBRANZA_ESTADO: "Estado de Cobranzas",
                COBRANZA_EXPORT: "Exportar Cobranzas",
                COBRANZA_EXPORT_IMPUTATION: "Exportar Cobranzas imputadas",
                COBRANZA_EXPORT_AGENCIA: "Exportar Cobranzas Agencia",
                COBRANZA_FILTRO_FECHA_INGRESO: "Ver filtro por fecha de ingreso de Cobranza",
                COBRANZA_TIPIFICAR: "Tipificar Cobranzas",
                COBRANZA_TIPIFICAR_FORZADO: "Tipificar Cobranzas de forma forzada"
            }
        }
    }
}

export default messages
